import { useState, useEffect } from "react";

function useLayout(rawLayout) {
  const [layout, setLayout] = useState(null);

  async function fetchSchema() {
    setLayout(await rawLayout());
  }

  useEffect(() => {
    fetchSchema();
  }, []);

  return layout;
}

export { useLayout };
